import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Alert } from '@artprov/design-system'
import { useDdjjMedicoStore } from '@/common/zustand/store/ddjj-medico.store'

/**
 * PBI 81147 (D6): toast global de carga exitosa de la DDJJ. Se monta en el layout
 * protegido porque el modal se desmonta al cerrarse y el aviso debe sobrevivirle.
 * Mismo formato que ToastSeleccionCuenta: portal, Alert success y autocierre a los 4 s.
 */
export default function AvisoCargaDdjj({ duracionMs = 4000 }) {
  const avisoExito = useDdjjMedicoStore((state) => state.avisoExito)
  const cerrarAviso = useDdjjMedicoStore((state) => state.cerrarAviso)

  useEffect(() => {
    if (!avisoExito) return undefined
    const timer = setTimeout(cerrarAviso, duracionMs)
    return () => clearTimeout(timer)
  }, [avisoExito, cerrarAviso, duracionMs])

  if (!avisoExito) return null

  return createPortal(
    <div className="fixed top-4 right-4 w-[400px]" style={{ zIndex: 99999 }}>
      <Alert
        variant="success"
        iconStyle="default"
        title=""
        description={avisoExito}
        descriptionStyle="whitespace-normal break-normal"
        interactive={true}
        buttonText=""
        onClose={cerrarAviso}
        containerStyle="!max-w-none w-full"
      />
    </div>,
    document.body
  )
}

AvisoCargaDdjj.propTypes = {
  duracionMs: PropTypes.number,
}
